module.exports = __webpack_public_path__ + "media/images/logo-creditcard-5cb79e8528e35f306215af3c373db308.svg";